module.exports = __webpack_public_path__ + "img/lta.364aec06.jpg";